import PropTypes from 'prop-types'

import DDIcon from '../../icons/DDIcon'
import styles from './HeroCard.module.css'

// Spec §5.11 — entry-screen hero (01) / returning-entry hero (R1). The tile grid is a
// CSS-pattern approximation of Figma's decorative 40px tile grid, left-fade masked.
const HeroCard = ({ title, body }) => (
  <div className={styles.card}>
    <div className={styles.tileGrid} aria-hidden='true' />
    <div className={styles.circle}>
      <DDIcon name='hero-hand' />
    </div>
    <div className={styles.title}>{title}</div>
    <div className={styles.body}>{body}</div>
  </div>
)

HeroCard.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
}

export default HeroCard
